import { render, staticRenderFns } from "./colorbarDatashadedForm.vue?vue&type=template&id=118aadcc"
import script from "./colorbarDatashadedForm.vue?vue&type=script&lang=js"
export * from "./colorbarDatashadedForm.vue?vue&type=script&lang=js"
import style0 from "./colorbarDatashadedForm.vue?vue&type=style&index=0&id=118aadcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports